import React from 'react';
import {Backdrop, Box, Fade, Modal} from "@mui/material";
import {word} from "../../word.js";
import BlueButton from "../BlueButton/BlueButton.js";
import qs from "query-string";
import {taskDataRequest} from "../../store/actions/task.js";
import {useDispatch} from "react-redux";
import Api from "../../Api.js";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 600 ? 600 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: 250,
    overflow: 'auto',
    maxHeight: '97vh'
};
function DeleteItem({open,setOpen,getCompanyFileData}) {
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const deleteTask = async () => {
        let querystring = qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })
        await Api.deleteFile(open)
        await getCompanyFileData(querystring)
        setOpen(0)
    }
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={!!open}
            onClose={() => setOpen(0)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className='employee-name-cont d-flex w-100 justify-content-center'>
                        <div className="delete-company">
                            <div className="delete-company-title">Ջնջե՞լ</div>
                            <div className="delete-commpany-button justify-content-between">
                                <BlueButton
                                    title={word.yes}
                                    onChangeValue={deleteTask}
                                />
                                <BlueButton
                                    title={word.no}
                                    onChangeValue={() => setOpen(0)}
                                />
                            </div>
                        </div>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default DeleteItem;